import React, { useRef, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import Input from '@material-ui/core/Input';
import { setFilters } from '../../actions/filters';
import CustomPropTypes from '../../helpers/CustomPropTypes';

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 540,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  mainActionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
    flexWrap: 'wrap',
    margin: theme.spacing(3, 0, 1.5, 0),
  },
  viewButton: {
    height: 36,
    marginRight: theme.spacing(2),
    borderRadius: 50,
  },
  search: {
    display: 'flex',
    alignItems: 'center',
  },
  filters: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    color: theme.palette.darkGrey.light,
    marginBottom: theme.spacing(4),
  },
  filterSmallButton: {
    marginRight: theme.spacing(1),
  },
  filterButton: {
    height: 36,
    color: theme.palette.primary.main,
    borderRadius: 50,
  },
  submitButton: {
    display: 'inline-block',
    maxWidth: '100%',
    minWidth: 'unset',
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 2),
    borderRadius: 12,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
  },
  filterContent: {
    width: 460,
    height: 300,
    maxWidth: '100%',
  },
  searchInput: {
    width: '100%',
    margin: theme.spacing(0, 2, 0, 0),
    paddingLeft: theme.spacing(1.5),
    backgroundColor: theme.palette.lightGrey.main,
    borderBottom: 'none',
    // borderRadius: 15,
    paddingTop: theme.spacing(1),
    fontFamily: 'Brilliant Cut Pro',
    '& input::placeholder': {
      color: theme.palette.darkGrey.main,
      // textTransform: 'uppercase',
      fontSize: 18,
      fontWeight: 500,
      opacity: 1,
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
  },
  searchIcon: {
    padding: theme.spacing(0.75, 1),
    marginTop: -theme.spacing(0.75),
    color: theme.palette.darkGrey.main,
  },
  clearIcon: {
    padding: theme.spacing(0.75, 1),
    marginBottom: '6px',
  },
}));

export const SearchPeople = ({
  entity, activeFilters, fetchParams,
  setFilters: dispatchSetFilters,
}) => {
  const classes = useStyles();
  const searchRef = useRef(null);

  const search = useCallback(() => {
    dispatchSetFilters(entity, { search: searchRef.current?.value }, fetchParams);
  }, [dispatchSetFilters, entity, fetchParams]);

  const clearSearch = useCallback(() => {
    if (activeFilters.search) dispatchSetFilters(entity, { search: undefined }, fetchParams);
    else if (searchRef.current) {
      searchRef.current.value = '';
      searchRef.current.blur();
    }
  }, [dispatchSetFilters, entity, fetchParams, activeFilters]);

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = activeFilters.search || '';
      if (!activeFilters.search) searchRef.current.blur();
    }
  }, [activeFilters.search]);

  return (
    <div className={classes.root}>
      <Input
        placeholder="Search by name, job title, company or role"
        defaultValue={activeFilters.search || ''}
        inputRef={searchRef}
        className={classes.searchInput}
        fullWidth={false}
        margin="dense"
        disableUnderline
        endAdornment={(
          <InputAdornment position="end">
            <IconButton onClick={search} className={classes.searchIcon}>
              <SearchIcon />
            </IconButton>
            {activeFilters.search && (
              <IconButton onClick={clearSearch} className={classes.clearIcon}>
                <ClearIcon />
              </IconButton>
            )}
          </InputAdornment>
        )}
        onKeyDown={(e) => {
          if (e.key === 'Enter') search();
        }}
      />
    </div>
  );
};

SearchPeople.propTypes = {
  entity: PropTypes.string.isRequired,
  activeFilters: PropTypes.objectOf(CustomPropTypes.filter).isRequired,
  fetchParams: PropTypes.objectOf(CustomPropTypes.filter),
  setFilters: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    meetingStatuses: PropTypes.objectOf(PropTypes.number),
  }).isRequired,
};

SearchPeople.defaultProps = {
  fetchParams: undefined,
};

const mapStateToProps = ({
  filters,
  entities,
  meta,
}, { entity }) => ({
  activeFilters: filters[entity],
  entities,
  meta,
});

export default connect(mapStateToProps, { setFilters })(SearchPeople);
